module.exports = __webpack_public_path__ + "img/4.6b8dc38e.jpg";